import { Empresa, Estabelecimento, Grupoempresarial } from '../../core/usuario/models/usuario-model';
import angular from 'angular';

export class ListagemService {

    static $inject = ['$rootScope'];

    private _empresasDoGrupoAtual: Empresa[] = [];

    constructor(
        public $rootScope: angular.IRootScopeService & { nsjGlobals: any }
    ) {
        this._empresasDoGrupoAtual = this.montaEmpresas(this.getGrupoEmpresarialAtual());
    }

    get empresasDoGrupoAtual() {
        return angular.copy(this._empresasDoGrupoAtual);
    }

    montaEmpresas(grupoEmpresarialCodigo: string, permissoes: string[] | null = null) {
        const grupo = this.getGruposEmpresariais().find((grp) => grp.codigo === grupoEmpresarialCodigo);

        if (!grupo) {
            return [];
        }

        if (!permissoes || !permissoes.length) {
            return grupo.empresas;
        }

        return grupo.empresas.filter(empresa => (
            this.temTodasPermissoes(empresa, permissoes)
        ));
    }

    montaEstabelecimentos(
        empresaId: string,
        empresas: Empresa[] | null = null,
        permissoes: string[] | null = null
    ) {
        if (!empresas) {
            empresas = this.empresasDoGrupoAtual;
        }

        const empresaSelecionada = empresas.find((empresa) => empresa.id === empresaId);

        if (!empresaSelecionada || !empresaSelecionada.estabelecimentos) {
            return [];
        }

        if (!permissoes || !permissoes.length) {
            return empresaSelecionada.estabelecimentos;
        }

        return empresaSelecionada.estabelecimentos.filter(estabelecimento => (
            this.temTodasPermissoes(estabelecimento, permissoes)
        ));
    }

    getEmpresa(
        empresaId: string,
        grupoEmpresarialCodigo: string = this.getGrupoEmpresarialAtual(),
        permissoes: string[] | null = null
    ) {
        const grupoPadrao = this.getGrupoEmpresarialAtual();

        let empresas: Empresa[];

        if (grupoEmpresarialCodigo === grupoPadrao) {
            empresas = this.empresasDoGrupoAtual;

            if (permissoes) {
                empresas = empresas.filter(empresa => this.temTodasPermissoes(empresa, permissoes));
            }
        } else {
            empresas = this.montaEmpresas(grupoEmpresarialCodigo, permissoes);
        }

        return empresas.find(empresa => empresa.id === empresaId);
    }

    private temTodasPermissoes(obj: Empresa | Estabelecimento, permissoes: string[]): boolean {
        return !!obj.permissoes && permissoes.every(perm => obj.permissoes.hasOwnProperty(perm));
    }

    private getGrupoEmpresarialAtual(): string {
        return this.$rootScope.nsjGlobals.a.grupoempresarial;
    }

    private getGruposEmpresariais(): Grupoempresarial[] {
        return angular.copy(this.$rootScope.nsjGlobals.a.permissoesagrupadas.gruposempresariais);
    }
}
